<div class="tab-content" style="max-height: 80vh;">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'USER'|translate}} {{this.operation=='create'?('CREATE'|translate):('UPDATE'|translate)}}</h1>
        </div>

        <mat-form-field style="padding: 0px 20px;" appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'NAME'|translate}} {{'SURNAME'|translate}}</mat-label>
            <input matInput placeholder="{{'NAME'|translate}} {{'SURNAME'|translate}}" required [(ngModel)]="model.name" name="name">
        </mat-form-field>

        <mat-form-field style="padding: 0px 20px;" appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'USERNAME'|translate}}</mat-label>
            
            <input matInput placeholder="{{'USERNAME'|translate}}" [(ngModel)]="model.userName" name="uname" required>
        </mat-form-field>

        <mat-form-field style="padding: 0px 20px;" appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'TITLE'|translate}}</mat-label>
            <input matInput placeholder="{{'TITLE'|translate}}" [(ngModel)]="model.title" name="title" required>
        </mat-form-field>


        <mat-form-field style="padding: 0px 20px;" *ngIf="operation=='create' || status=='update'&& !passChange" appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label><span *ngIf="status=='update'&&!passChange">{{'OLD'|translate}} </span> {{'PASSWORD'|translate}}</mat-label>
            <input matInput type="password" pattern="(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!.,@#\$%\^\&*]{6,}"
                [(ngModel)]="model.password" placeholder="{{'PASSWORD_GENERATOR'|translate}}" name="pass"
                required>
        </mat-form-field>

        <mat-form-field style="padding: 0px 20px;" *ngIf="status=='update'&& !passChange"
            appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label><span *ngIf="status=='update'">{{'NEW'|translate}} </span>{{'PASSWORD'|translate}}</mat-label>
            <input matInput type="password" pattern="(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!@#\$%\^\&*]{6,}"
                [(ngModel)]="UpdateModel.NewPassword" placeholder="{{'PASSWORD_GENERATOR'|translate}}"
                name="newpass" required>
        </mat-form-field>

        
        <div *ngIf="status=='update'" style="padding: 0px 20px 20px 20px; display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
            <button *ngIf="status=='update'" mat-raised-button (click)="passChange=!passChange">
                {{'PASSWORD'|translate}} {{passChange?("CHANGE"|translate):("NOT_CHANGE"|translate)}}
            </button>

            <button *ngIf="status=='update'" mat-raised-button
                (click)="fileStatus=!fileStatus" style="display: inline;">
                {{'FILE'|translate}} {{fileStatus?("CHANGE"|translate):("NOT_CHANGE"|translate)}}
            </button>
        </div>

        <div fxLayout="row wrap">

            <div style="display: flex; align-items: center;" *ngIf="status=='create'|| !fileStatus"
                fxFlex="100" fxFlex.gt-md="30" class="user-file-input">
                <form enctype="multipart/form-data">
                    <input (change)="fileChange($event.target.files)" accept=".jpg,.jpeg,.png" type="file"
                        placeholder="Basic outline placeholder">
                </form>
            </div>

            <mat-form-field *ngIf="companyId==1" style="padding: 0px 20px;" fxFlex="100" fxFlex.gt-md="20"
                appearance="outline">
                <mat-label>{{'COMPANY'|translate}}</mat-label>
                <mat-select [(ngModel)]="model.companyId" placeholder="{{'COMPANY'|translate}}" name="company">
                    <mat-option *ngFor="let i of this.company" [value]="i.id">
                        {{i.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="padding: 0px 20px;" fxFlex="100" fxFlex.gt-md="20" appearance="outline">
                <mat-label>{{'STATUS'|translate}}</mat-label>
                <mat-select [(ngModel)]="model.active" placeholder="{{'STATUS'|translate}}" name="status">
                    <mat-option [value]=1>
                        {{'ACTIVE'|translate}}
                    </mat-option>
                    <mat-option [value]=0>
                        {{'PASSIVE'|translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="padding: 0px 20px;" fxFlex="100" fxFlex.gt-md="20" appearance="outline">
                <mat-label>{{'ROLE'|translate}}</mat-label>
                <mat-select [(ngModel)]="model.role" placeholder="{{'ROLE'|translate}}" name="role">
                    <mat-option [value]=1>
                        {{'DRIVER'|translate}}
                    </mat-option>
                    <mat-option [value]=0>
                        {{'MANAGER'|translate}}
                    </mat-option>
                    <mat-option [value]=2>
                        {{'PERSONEL'|translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <button mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>